module.exports = __webpack_public_path__ + "img/isolated-vegetables.53ba4b1f.jpg";